import { createIcon } from '../createIcon';

export const VrCardboardIconConfig = {
  name: 'VrCardboardIcon',
  height: 512,
  width: 640,
  svgPath: 'M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const VrCardboardIcon = createIcon(VrCardboardIconConfig);

export default VrCardboardIcon;